export default __webpack_public_path__ + "static/media/swap-horizontal.5065e97b.svg";